module.exports = __webpack_public_path__ + "static/media/AvertaStd-Semibold.8c9f00fa.woff2";